<template>
  <div>
    <div class="itemRow text-left" v-for="item in order.orderData">
      <table class="maxw items" v-if="item.isCoupon">
        <tr>
          <td class="counter">1x</td>
          <td class="b text-left">
            <div style="">
              <div class="biggerFont">{{ item.nameToDisplay }}
                <span v-if="item.description"> | {{ item.description }}</span>
              </div>
              <div v-if="item.text.length > 0" class="displayExtras">
                {{ item.text }}
              </div>
              <!--                                    <div v-if="item.text.length > 0" class="displayExtras">-->
              <!--                                        {{item.text}}-->
              <!--                                    </div>-->
            </div>

          </td>
          <!--                        <td class="counter">Anzahl: {{item.count}}</td>-->
          <td class="e text-right" v-if="!$store.getters.hidePrices">
            <div v-if="item.type==='bundle'">{{ item.amount | price }}</div>
            <div v-if="item.type==='amount'">-{{ item.amount | price }}</div>
            <div v-if="item.type==='discount'">-{{ item.discount }}%</div>
          </td>
        </tr>
      </table>
      <table class="maxw items" v-else>
        <tr>
          <td class="counter biggerFont">{{ item.count }}x</td>
          <td class="b text-left">
            <div style="">
              <div>
                <div v-if="item.gang" class="gang">{{ item.gang | uppercase }}:</div>
                <span>{{ item.nameToDisplay }} {{ displayItemVol(item) }}
                  <!-- <spanv-if="item.description"> | {{item.description}}</span>-->
                                </span>
              </div>
              <div v-if="item.extras.length > 0" class="displayExtras">
                {{ item.extras | extrasList(true) }}
              </div>
              <div v-if="item.notes" class="font-italic">{{ item.notes }}</div>
              <!--                            <div class="displayExtras" v-if="item.notes.length > 0">Anmerkung:&nbsp;<span-->
              <!--                                    class="notes">{{item.notes}}</span></div>-->
            </div>

          </td>
          <!--                        <td class="counter">Anzahl: {{item.count}}</td>-->
          <td class="e text-right" v-if="!$store.getters.hidePrices">{{ item.itemTotal | price }}</td>
        </tr>
        <!--                <tr v-if="order.note && order.note.length > 0">-->
        <!--                    <td colspan="2">-->
        <!--                        <div class="pt-3 pb-3 biggerFont">Hinweis: {{order.note}}</div>-->
        <!--                    </td>-->
        <!--                    <td></td>-->
        <!--                </tr>-->
      </table>
    </div>


    <div class="text-right flex-grow-1 itemRow" style="border: none">
      <div class="d-inline-block">
        <table class="mySumTable">
          <tr v-if="order?.paymentInfo?.tipAmount">
            <td>Trinkgeld:</td>
            <td>{{ order.paymentInfo.tipAmount | price }}</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="itemRow text-right" style="border: none">
      <h3>Gesamt: {{ order.paymentInfo.amount | price }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    order: Object,
  },

  methods: {
    displayItemVol(item) {
      if (item.vol.length === 0 || item.vol.toLowerCase().indexOf('standard') !== -1) {
        return '';
      } else {
        return item.vol;
      }
    },
  },

}
</script>

<style scoped lang="scss">
@import '../styles/base';

.mySumTable {
  td {
    padding-left: 12px;
  }
}

.gang {
  text-decoration: underline;
  display: inline-block;
  margin-right: 2px;
  /*padding: 1px 6px;*/
  /*background-color: black;*/
  /*color: white;*/
}

.notes {
  font-style: italic;
}

.itemRow {
  border-bottom: 1px solid #666;
  margin: 15px 8px;
  padding: 4px 8px;
}

.items {
  /*border-collapse: collapse;*/

  td {
    //background-color: $color-darkblue;
  }

  .a {
    width: 38px;
  }

  .b {
    width: auto;
  }

  .c {

  }

  .d {

  }

  .e {
    width: 60px;
  }

  .f {
    width: 30px;
  }
}

td.counter {
  width: 38px;
  vertical-align: top;
}

.displayExtras {
  color: rgba($font-color, 0.8);
}
</style>
